/**
 * Depending on whether the planner has stated that they know the event
 * address or venue name we want to toggle which input elements are
 * enabled and shown on the event location step.
 */
function initializeEventLocation() {
	const quoteRequest = this.collect();
	const knownAddressOrVenue = quoteRequest.get('known_address_or_venue');

	const eventCityContainer = this.currentStepElement.querySelector('.js-quote-request-event-city');
	const eventCityAndVenueContainer = this.currentStepElement.querySelector('.js-quote-request-event-venue-and-city');

	if (knownAddressOrVenue === 'yes') {
		eventCityContainer.classList.add('js-hide');
		eventCityContainer.querySelectorAll('input').forEach((input) => {
			input.disabled = true;
		});

		eventCityAndVenueContainer.classList.remove('js-hide');
		eventCityAndVenueContainer.querySelectorAll('input').forEach((input) => {
			input.disabled = false;
		});

		const locationAutocompleteInput = this.currentStepElement.querySelector('.js-location-input');
		const locationAutocompleteId = this.currentStepElement.querySelector('#location-id');
		const locationAutocompleteDetails = this.currentStepElement.querySelector('#location-details');
		const locationAutocompletePostalCode = this.currentStepElement.querySelector('#location-postal-code');
		const locationAutocompleteFullAddress = this.currentStepElement.querySelector('#location-full-address');

		// truncate the autocomplete value based on the resultType
		function getUserFacingLocationString(locationDetails) {
			if (!locationDetails || typeof locationDetails !== 'object') {
				return locationAutocompleteInput.value;
			}

			let locationString = locationDetails.title;
			if (locationDetails.resultType === 'houseNumber') {
				locationString = `${locationDetails.address.houseNumber} ${locationDetails.address.street}`;
			} else if (locationDetails.resultType === 'locality') {
				if (locationDetails.localityType === 'district') {
					locationString = locationDetails.address.district;
				} else if (locationDetails.localityType === 'postalCode') {
					locationString = locationDetails.address.postalCode;
				}
			} else if (locationDetails.resultType === 'street') {
				locationString = locationDetails.address.street;
			} else if (locationDetails.resultType === 'intersection') {
				locationString = locationDetails.address.streets.join(' & ');
			} else if (typeof locationDetails.address.houseNumber !== undefined || typeof locationDetails.address.street !== undefined) {
				locationString += ',';
				locationString += (locationDetails.address.houseNumber) ? ` ${locationDetails.address.houseNumber}` : '';
				locationString += (locationDetails.address.street) ? ` ${locationDetails.address.street}` : '';
			}

			// Make sure we return something to show in the autocomplete field even if one of the assignments above was undefined
			if (typeof locationString == 'undefined') {
				locationString = locationDetails.title;
			}

			return locationString;
		}

		if (locationAutocompleteInput) {
			const cityInput = this.currentStepElement.querySelector('#quote-request-event-address-city');
			const parent = this;
			let hereLocationDetails;
			// after an address or venue is selected from the autocomplete input, use the
			// result details to fill the event city input field and retrieve the locations-cities-id
			$('#quote-request-event-address-or-venue-name').autocompleteLocation({
				// don't let the autocompleteLocation plugin populate the input field
				// since we'll just be immediately replacing it with our truncated string
				disableResultInputPopulation: true,
				resultDetailsLoaded: function(locationDetails) {
					locationAutocompleteInput.value = getUserFacingLocationString(locationDetails);
					cityInput.value = `${locationDetails.address.city}, ${locationDetails.address.stateCode}`;
					locationAutocompletePostalCode.value = locationDetails.address.postalCode;
					parent.clearErrors();
					hereLocationDetails = locationDetails;

					// rebuild the full address that we're suppressing from the response from the plugin
					let fullAddress = hereLocationDetails.address.label;
					fullAddress = fullAddress.replace(new RegExp('(-[0-9]{4})?, (United States)$', 'i'), ''); // remove +4 portion of zip code, if any, along with "United States" from these address labels
					fullAddress = fullAddress.replace(new RegExp(', Puerto Rico, Puerto Rico$', 'i'), ', Puerto Rico'); // PR cities have the country name duplicated in these results
					fullAddress = fullAddress.replace(new RegExp(', Puerto Rico(( [0-9]{5})(-[0-9]{4})?)?$', 'i'), ', PR$2'); // ensure Puerto Rico is displayed as PR and no +4 zip code portions show
					fullAddress = fullAddress.replace(new RegExp(', Canada$', 'i'), ''); // remove "Canada" from address labels

					locationAutocompleteFullAddress.value = fullAddress;
					// add the user input to the location details so it also gets stored in the db
					locationDetails.user_input = fullAddress;
					locationAutocompleteDetails.value = JSON.stringify(locationDetails);
				},
				resultCleared: function() {
					hereLocationDetails = null;
				}
			});

			locationAutocompleteInput.addEventListener('blur', () => {
				if (locationAutocompleteInput.value && !locationAutocompleteInput.dataset.autocompleteStateMouseDownOnSelect) {
					locationAutocompleteInput.value = getUserFacingLocationString(hereLocationDetails);
				}
			});

			// Clear the location field if the city is manually changed
			// so locations with mismatched cities don't get submitted
			const relevantEvents = ['input', 'change'];
			for (const event of relevantEvents) {
				cityInput.addEventListener(event, () => {
					hereLocationDetails = null;
					locationAutocompleteFullAddress.value = '';
					locationAutocompletePostalCode.value = '';
					locationAutocompleteInput.dataset.selectedLocationName = '';
					locationAutocompleteInput.value = '';
					locationAutocompleteId.value = '';
					locationAutocompleteDetails.value = '';
					locationAutocompleteInput.classList.remove('valid');
				});
			}
		}
	} else {
		eventCityAndVenueContainer.classList.add('js-hide');
		eventCityAndVenueContainer.querySelectorAll('input').forEach((input) => {
			input.disabled = true;
		});

		eventCityContainer.classList.remove('js-hide');
		eventCityContainer.querySelectorAll('input').forEach((input) => {
			input.disabled = false;
		});
	}
}

export {
	initializeEventLocation
}